<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Article Tags'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Article Tags'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'slug',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'articleTags/index',
            deleteItem: 'articleTags/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/article-tags/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/article-tags/add');
        }
    }
};
</script>
